export default "__VITE_ASSET__D7OilPt6__"